import React from "react";
import Link from "helpers/link";
import { getButtonStyle } from "helpers/get-button-style";
import { useMediaQuery } from "react-responsive";
import { useStickyState } from "hooks/useStickyElement";
import { useSelector } from "react-redux";
import clsx from "clsx/lite";

const computeStyles = (type) => {
	switch (type) {
		case "mobile":
			return "md:flex hidden";
		case "desktop":
			return "md:hidden flex";
		case "bothViews":
			return "hidden";
		default:
			return "flex";
	}
};

const Button = ({ data = {}, className = "", textUnderneathClass = "", containerClassName = "" }) => {
	if (!data?.url || !data?.text) return null;
	const { subscriptionId } = useSelector((state) => state.account.subscription);
	const url = subscriptionId ? data.subscriptionUrl ?? data.url : data.url;
	const text = subscriptionId ? data.subscriptionText ?? data.text : data.text;
	const textUnderneath = subscriptionId ? data.subscriptionTextUnderneath ?? data.textUnderneath : data.textUnderneath;

	const styles = computeStyles(data?.hide);
	const isMobile = useMediaQuery({ query: "(max-width: 767px)" });
	const isSticky = useStickyState(data?.stickyCTA);

	const containerClass = clsx(
		styles, data.stickyCTA && "make-sticky", isSticky && data.stickyCTA && isMobile && "sticky-cta",
		"flex-col items-center gap-4 w-fit",
		data.center ? "justify-center mx-auto" : "justify-start ml-0", containerClassName
	);

	if (!textUnderneath) {
		return (
			<Link to={url} className={clsx(className, containerClass, getButtonStyle(data.style), data.center && "mx-auto")}>
				{text}
			</Link>
		);
	}

	return (
		<div className={containerClass}>
			<Link to={url} className={clsx(className, getButtonStyle(data.style))}>
				{text}
			</Link>
			<p className={clsx(data.center ? "w-auto" : "w-full", textUnderneathClass)}>{textUnderneath}</p>
		</div>
	);
};

export default Button;